import { useEffect } from "react";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useInView } from "react-intersection-observer";
import { toast } from "react-toastify";

import dateFormatter from "../../util/dateFormatter";
import useNotificationService from "../../services/api/notificationService";
import { enums } from "../../constants/enum";

import { Badge, Loading, Section } from "../../components";

import "./NotificationsPage.scss";

export default function History() {
  const { ref, inView } = useInView();
  const { getSmsHistory } = useNotificationService();
  const { data, isLoading, error,fetchNextPage, isFetchingNextPage } = useInfiniteQuery({
    queryKey: [getSmsHistory.queryKey, "ALL"],
    queryFn: ({ pageParam = 1 }) => getSmsHistory(undefined, false, pageParam),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      if (lastPage?.totalPages > lastPage?.currentPage) {
        return lastPage?.currentPage + 1;
      }
      return undefined;
    },
  });


  useEffect(() => {
    if (inView) {
      fetchNextPage();
    }
  }, [fetchNextPage, inView]);

  if (isLoading) {
    return <Loading variant="fullScreen" />;
  }

  if (error) {
    toast.error(error.message || enums.DEFAULT_ERROR_MESSAGE);
  }

  return (
    <div className="history-section">
      <div className="history-section-content">
        <h1>History</h1>

        <div className="history-grid">
          {data.pages.map(({ messages }) =>
            messages.map((item) => (
              <Section
                key={item._id}
                wrapperClassName="history-card-wrapper"
                className="history-card-content"
              >
                <div className="card-header-badge">
                  <Badge text={`${item.type}  ( ${item.smsContentNature} ) MESSAGE`} />
                </div>

                <div className="card-meta-row">
                  <div className="meta-item">
                    <Badge text="Created At" className="meta-badge" />
                    <span className="meta-value">
                      {
                    dateFormatter(item.createdAt, true)}
                    </span>
                  </div>
                </div>

                <div className="card-meta-row">
                  <div className="meta-item">
                    <Badge text="Receiver Count" className="meta-badge" />
                    <span className="meta-value">{item.to?.length || 0}</span>
                  </div>
                </div>

                <div className="message-box">
                  <Badge text="Message" className="floating-label" />
                  <p>{item.message}</p>
                </div>
              </Section>
            )),
          )}
        </div>
          <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "20px 0",
                }}
                ref={ref}
              >
                {isFetchingNextPage ? <Loading variant="inline" /> : null}
              </div>
      </div>
    </div>
  );
}
